const DATE_RANGES = [
  { text: 'Custom Date Range', value: 'custom' },
  { text: 'Today', value: 'today' },
  { text: 'Yesterday', value: 'yesterday' },
  { text: 'Last 7 Days', value: 'last7days' },
  { text: 'Last 30 Days', value: 'last30days' },
];

export const REPORT_DATE_RANGES = [
  { text: 'Custom Date Range', value: 'custom' },
  { text: 'Today', value: 'today' },
  { text: 'Weekly', value: 'weekly' },
  { text: 'Monthly', value: 'monthly' },
  { text: 'Yearly', value: 'yearly' },
];

export const AGING_DATE_RANGE = [
  { text: 'Until today', value: 'until_today' },
  { text: 'More than 3 days', value: 'more_than_3_days' },
  { text: 'More than 7 days', value: 'more_than_7_days' },
  { text: 'More than 14 days', value: 'more_than_14_days' },
  { text: 'More than 30 days', value: 'more_than_30_days' },
];

export default DATE_RANGES;



// WEBPACK FOOTER //
// ./src/constants/dateRanges.js